import { useContext, useMemo } from 'react';

import './VendorLeadStepGuide.scss';

import { HtmlPreview } from 'src/components/base/HtmlPreview';
import { VendorsContext } from 'src/pages/VendorsPage/VendorsPage.context';

export function VendorLeadStepGuide() {
  const { vendorLeadProductSpecification, vendorStepGuideKey } = useContext(VendorsContext);

  const htmlContent = useMemo(
    () => (vendorStepGuideKey && vendorLeadProductSpecification?.fieldGroupGuides[vendorStepGuideKey]) ?? undefined,
    [vendorStepGuideKey, vendorLeadProductSpecification?.fieldGroupGuides]
  );

  return (
    <div className="vendor-lead-step-guide__container">
      <HtmlPreview content={htmlContent} className="vendor-lead-step-guide__preview" />
    </div>
  );
}
